import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  body {
    font-size: 1em;
    font-family: 'Shadows Into Light', cursive;
  }
`;